import { setSettingsItems } from '../windowMessaging/windowMessaging';

const tabUpdateConfig = {
  pagesToTrack: ['https://app-?\\w*.hubspot.com'],
};

export const postChromeTabUpdateConfig = () => {
  setSettingsItems({ tabUpdateConfig });
};
